export default __webpack_public_path__ + "static/media/whyclapingo.612761fc.png";